<template>
  <div>
    <div class="popup-title">请先完成登录</div>
    <cube-form :model="forms">
      <div class="oinput">
        <img src="~@/group/images/phone.png" />
        <cube-input @blur="vphone" placeholder="请输入手机号" type="number" v-model="forms.phone"></cube-input>
      </div>
      <div class="oinput oinput-2">
        <img class="code-img" src="~@/group/images/code.png" />
        <cube-input
          @blur="vphone"
          @input="vphone"
          placeholder="请输入验证码"
          type="number"
          v-model="forms.password"
        ></cube-input>
        <cube-button
          :inline="true"
          :outline="false"
          @click="send"
          class="getcode"
          v-bind:class="{'isSend':isSend}"
        >{{sendCode}}</cube-button>
      </div>
      <cube-button :disabled="!ispass" @click="login" v-bind:class="{'login-btn':ispass}">登录</cube-button>
    </cube-form>
    <div class="tips" @click="goRegister">
      未注册？
      <span class="red">立即注册</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ispass: false,
      sendCode: '获取验证码',
      forms: {
        phone: '',
        password: '',
        scope: 'all',
        type: 'H5',
        grant_type: 'password'
      },
      vphones: '',
      isSend: false
    }
  },
  methods: {
    login() {
      if (!this.forms.password) return this.$warn('请填写验证码!')
      this.$groupLoading().show()
      this.$groupPost('auth/oauth/login', {
        phone: this.forms.phone,
        password: this.forms.password,
        type: this.forms.type,
        scope: this.forms.scope,
        grant_type: this.forms.grant_type
      }).then(data => {
        this.$groupLoading().hide()
        if (data.errCode === 0) {
          this.$success('登录成功')
          this.$emit('success')
        }
      })
    },
    vphone(e) {
      window.scroll(0, 0)
      const phone = this.forms.phone
      if (!/^\d{11}$/.test(phone)) {
        if (phone) {
          this.$warn('请输入正确的手机号')
        }
        this.vphones = false
        return false
      } else {
        this.vphones = true
      }
    },
    send() {
      if (this.vphones) {
        if (!this.isSend) {
          this.$groupLoading().show()
          this.$groupPost('group/sms/h5/sendMessage', {
            phone: this.forms.phone
          }).then(data => {
            this.$groupLoading().hide()
            if (data.errCode == 0) {
              this.isSend = true
              this.ispass = true
              this.countDown(60)
              this.$success('发送成功！')
            }
          })
        }
      } else {
        this.$warn('请输入正确的手机号')
      }
    },
    countDown(num) {
      this.sendCode = `${num}s`
      const times = setInterval(() => {
        if (num == 0) {
          this.sendCode = '获取验证码'
          this.isSend = false
          clearInterval(times)
        } else {
          num--
          this.sendCode = `${num}s`
        }
      }, 1000)
    },
    reset() {
      this.forms.phone = ''
      this.forms.password = ''
    },
    goRegister() {
      this.$emit('change', 1)
    }
  },
  created() {},
  mounted() {}
}
</script>

<style lang='scss' scoped>
.popup-title {
  font-size: 34px;
  font-family: Arial;
  font-weight: 400;
  line-height: 37px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  margin-bottom: 25px;
}
.oinput {
  display: flex;
  justify-content: start;
  align-items: center;
  img {
    margin-left: 22px;
    width: 38px;
    height: 50px;
    margin-right: 20px;
  }
  .code-img {
    width: 45px;
    height: 42px;
  }
  .cube-input-field {
    border: none;
  }
  .getcode {
    background: #fff;
    flex-shrink: 0;
    font-size: 30px;
    font-family: Arial;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    border: none;
  }
  .isSend {
    color: #eb1d1e;
    border: none;
  }
}
.oinput-2 {
  margin: 20px 0 30px;
  img {
    margin-left: 20px;
  }
}
.login-btn {
  background: linear-gradient(
    270deg,
    rgba(233, 0, 0, 1) 0%,
    rgba(242, 86, 86, 1) 100%
  );
  color: #fff;
}
.tips {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-size: 32px;
  line-height: 44px;
  text-align: center;
  margin-top: 40px;
  color: #999;
  white-space: nowrap;
  .red {
    color: #eb1d1e;
    font-size: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/group/components/login/components/login.vue